import React from 'react';
import { motion } from 'framer-motion';
import { Gift, BookOpen, Utensils, Moon, ShieldPlus, Zap, Check } from 'lucide-react';
export function OfferStack() {
  const items = [{
    icon: <BookOpen size={24} className="text-accent" data-id="element-130" />,
    title: 'Ebook Maestro: Peri-menopausia Rebelde',
    value: '$49.99',
    isMain: true
  }, {
    icon: <Utensils size={24} className="text-health" data-id="element-131" />,
    title: 'Bono #1: Plan de Comidas Cero Inflamación',
    value: '$29.99',
    isMain: false
  }, {
    icon: <Moon size={24} className="text-indigo-500" data-id="element-132" />,
    title: 'Bono #2: Protocolo de Sueño Profundo 3-2-1',
    value: '$47.00',
    isMain: false
  }, {
    icon: <ShieldPlus size={24} className="text-orange-500" data-id="element-133" />,
    title: 'Bono #3: Lista de Súper Escudo Hormonal',
    value: '$27.00',
    isMain: false
  }];
  return <section id="offer-section" className="py-24 px-4 bg-text-primary text-white relative overflow-hidden" data-id="element-134">
      {/* Decorative background */}
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-accent via-transparent to-transparent" data-id="element-135"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-136">
        <div className="text-center mb-12" data-id="element-137">
          <h2 className="text-4xl sm:text-5xl font-serif font-bold mb-4" data-id="element-138">
            Esto es todo lo que recibes hoy
          </h2>
          <p className="text-xl text-white/70" data-id="element-139">
            Un paquete completo diseñado para resultados rápidos y sostenibles.
          </p>
        </div>

        <div className="bg-white text-text-primary rounded-3xl p-6 sm:p-10 shadow-2xl" data-id="element-140">
          <div className="space-y-4 mb-8" data-id="element-141">
            {items.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className={`flex items-center justify-between p-4 rounded-2xl border ${item.isMain ? 'bg-accent/10 border-accent/30' : 'bg-primary-bg border-text-primary/10'}`} data-id="element-142">
                <div className="flex items-center gap-4" data-id="element-143">
                  <div className={`p-3 rounded-xl ${item.isMain ? 'bg-white shadow-sm' : 'bg-white'}`} data-id="element-144">
                    {item.icon}
                  </div>
                  <span className={`font-bold sm:text-lg ${item.isMain ? 'text-text-primary' : 'text-text-primary/80'}`} data-id="element-145">
                    {item.title}
                  </span>
                </div>
                <span className="font-mono text-text-primary/50 line-through hidden sm:block" data-id="element-146">
                  {item.value}
                </span>
              </motion.div>)}
          </div>

          <div className="border-t-2 border-dashed border-text-primary/20 pt-8 mb-8" data-id="element-147">
            <div className="flex justify-between items-end mb-2" data-id="element-148">
              <span className="text-xl font-bold text-text-primary/60" data-id="element-149">
                Valor Total:
              </span>
              <span className="text-2xl font-mono text-text-primary/60 line-through decoration-red-500/50 decoration-2" data-id="element-150">
                $153.98
              </span>
            </div>
            <div className="flex justify-between items-end bg-accent/10 p-6 rounded-2xl border border-accent/30" data-id="element-151">
              <span className="text-2xl sm:text-3xl font-black text-text-primary uppercase" data-id="element-152">
                Hoy Solo:
              </span>
              <span className="text-5xl sm:text-6xl font-black text-accent-dark tracking-tighter" data-id="element-153">
                $6.36 <span className="text-2xl text-accent" data-id="element-154">USD</span>
              </span>
            </div>
          </div>

          <div className="flex flex-col items-center gap-4" data-id="element-155">
            <a href="https://myschoolofbusiness.com/cart/47422073733314:1" target="_blank" rel="noopener noreferrer" className="w-full py-6 bg-accent hover:bg-accent-dark text-white rounded-2xl font-black text-2xl sm:text-3xl shadow-[0_10px_30px_rgba(212,163,115,0.4)] hover:shadow-[0_15px_40px_rgba(188,108,37,0.5)] transition-all transform hover:-translate-y-1 flex items-center justify-center gap-3 animate-pulse-slow" data-id="element-156">
              QUIERO ACCEDER HOY POR $6.36
              <Zap size={28} className="fill-current" data-id="element-157" />
            </a>

            <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm text-text-primary/60 font-bold uppercase tracking-wider" data-id="element-158">
              <span className="flex items-center gap-1" data-id="element-159">
                <Check size={16} className="text-health" data-id="element-160" /> Un solo pago
              </span>
              <span className="flex items-center gap-1" data-id="element-161">
                <Check size={16} className="text-health" data-id="element-162" /> Acceso inmediato
              </span>
              <span className="flex items-center gap-1" data-id="element-163">
                <Check size={16} className="text-health" data-id="element-164" /> Sin mensualidades
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}